"use strict";

/**
 * @module Services.MetricCollectors
 */
var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return _extendStatics(d, b);
  };
  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    _extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TopicMetricCollectorImpl = void 0;
var abstract_metric_collector_1 = require("./abstract-metric-collector");
/**
 * A topic metric collector.
 */
var TopicMetricCollectorImpl = /** @class */function (_super) {
  __extends(TopicMetricCollectorImpl, _super);
  /**
   * Create a new TopicMetricCollector instance
   *
   * @param name                       identity
   * @param exportToPrometheus         whether to expose the collector through the Prometheus gateway
   * @param topicSelector              identifies the target topics
   * @param groupByTopicType           whether to group the results by topic type
   */
  function TopicMetricCollectorImpl(name, exportToPrometheus, maximumGroups, topicSelector, groupByTopicType, groupByTopicView, groupByPathPrefixParts) {
    var _this = _super.call(this, name, exportToPrometheus, maximumGroups) || this;
    _this.topicSelector = topicSelector;
    _this.groupByTopicType = groupByTopicType;
    _this.groupByTopicView = groupByTopicView;
    if (groupByPathPrefixParts < 0) {
      throw new Error("groupByPathPrefixParts must be non-negative: " + groupByPathPrefixParts);
    }
    _this.groupByPathPrefixParts = groupByPathPrefixParts;
    return _this;
  }
  return TopicMetricCollectorImpl;
}(abstract_metric_collector_1.AbstractMetricCollector);
exports.TopicMetricCollectorImpl = TopicMetricCollectorImpl;